import React from 'react';
import Relay from 'react-relay';

import DateField from './DateField';
import TextField from './TextField';
import Select from 'react-select';
import Dialog from 'react-bootstrap-dialog';

import UserList from './UserList'

import { isValidEmailAddress } from './UserPanel'

import {cloneDeep} from 'lodash';

class CirclePanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      autocompleteUsersQuery: '',
      autocompleteUserSelected: null,
      isEditing: props.isEditing,
      form: {},
    }
  }

  componentDidMount() {
    this.setState({
      form: {
        name: this.props.viewer.circle.name
      }
    })
  }

  componentDidUpdate(prevProps, prevState){

    let circle = this.props.viewer.circle;

    this.refs.creation_status = this._getCreationStatus(circle);
  }

  _handleReasonChange(event, circle) {
    circle.creation_status.reason = event.target.value;
    this.setState({
      currentCircle: {
        node: circle
      }
    });
  }

  onValidateButtonClick() {
    let { circle } = this.props.viewer;

    circle.creation_status = {
      reason: null,
      status: "VALIDATED" 
    };

    let newCircle = cloneDeep(circle);
    
    delete newCircle.address;
    delete newCircle.__dataID__;
    delete newCircle.mode;
    delete newCircle.type;
    delete newCircle.sport;
    delete newCircle.publicShortCode;
    delete newCircle.id;
    // Log
    console.log("original circle : ", circle);
    console.log("deepCloned circle : ", newCircle);
    let circleId = circle.id
    if (this._validCircle(newCircle))
       this.props.onUpdateCircle(newCircle, circleId);
    else
      alert('invalid circle');
  }

  onDeleteButtonClick() {
    let { circle } = this.props.viewer;
    circle.creation_status.status = "REJECTED" ;

    if (this._validSportunity(circle))
       this.props.onUpdateCircle(circle);
    else
      alert('invalid sportunity');
  }

  _validCircle(circle) {
    return true;
  }

  _getCreationStatus(circle) {
    let creation_status = "";
    if (circle && circle.creation_status && circle.creation_status.status)
      creation_status = circle.creation_status.status;

    return creation_status ;
  }


  _renderTextField(fieldName, fieldContent) {
    return (
      <div style={{display: 'flex',flexDirection:'row', paddingBottom:5, paddingTop:10, paddingLeft:20}}>
        <label>{fieldName} :</label>
        <div style={{paddingLeft:20}} >
          {fieldContent}
        </div>
      </div>
    );
  }

  _renderStatusField(circle) {
    let status = this._getCreationStatus(circle);

    return (
      <div style={{display: 'flex',flexDirection:'row', paddingBottom:5, paddingTop:10, paddingLeft:20}}>
        <label>Status :</label>
        <input style={{marginLeft:10}} ref="creation_status" value={status} disabled/>
      </div>
    );
  }

  _renderValidateButton() {
    return (
      <div style={{paddingLeft:20, display:'flex', flex:1, flexDirection:'center', alignItems:'center', marginTop:20}}>
        <button type="button" className="btn btn-lg btn-success" onClick={this.onValidateButtonClick.bind(this)}>Validate</button>
      </div>
    );
  }

  _renderRejectButton(circle) {
    return (
      <div style={{paddingLeft:20, alignItems:'center', marginTop:20}}>
        <div>
          <label>Reason to reject the circle:</label>
          <input
            ref="reason"
            className="form-control"
            placeholder="Reason"
            defaultValue={circle.creation_status.reason}
            onChange={(e) => this._handleReasonChange(e, circle)}
          />
        </div>
        <div>
          <button style={{marginTop: 10}} type="button" className="btn btn-lg btn-danger" onClick={this.onDeleteButtonClick.bind(this)}>Reject</button>
        </div>
      </div>
    );
  }

  // Button Modify
  onModifyButtonClick = () =>
    this.setState(({ isEditing }) => ({
      isEditing: !isEditing,
    }))

  onSaveButtonClick = () =>  
      this.props.onUpdate(this.state.form)

  _renderEditButton = (circle) =>
    <div style={{paddingLeft:20, display:'flex', flex:1, flexDirection:'center', alignItems:'center', marginTop:20}}>
      <button
        type="button"
        className={
          'btn btn-sm '+
          (this.state.isEditing? 'btn-danger' : 'btn-success')
        }
        onClick={this.onModifyButtonClick}
      >
        {this.state.isEditing? 'Cancel' : 'Modify'}
      </button>
      {this.state.isEditing &&
        <button
          type="button"
          className="btn btn-sm btn-success"
          onClick={this.onSaveButtonClick}
        >
          Save
        </button>
      }
    </div>


  _renderStatusButtons(circle, status) {

    if (status == "PENDING")
      return (
        <div>
          {this._renderValidateButton()}
          {this._renderRejectButton(circle)}
        </div>
      );
    else if (status == "VALIDATED")
      return (
        <div>
          {this._renderRejectButton(circle)}
        </div>
      );
    else
      return (
        <div>
          {this._renderValidateButton()}
        </div>
      );
  }

  setForm = (value) => this.setState((prevState) => ({
    form: {
      ...prevState.form,
      ...value,
    },
  }))

  renderOption = (option) => (
		<div style={{ display: 'flex', flexDirection: 'row'}}>
      <img src={option.user.avatar} style={{ height: 20, width: 'auto', padding: 4, verticalAlign: 'middle' }} />
      {option.label}
    </div>
	)


  render() {
    const { circle } = this.props.viewer;

    return (
      <table className="table table-hover table-condensed table-bordered">
        <tbody>
        <tr>
            <td>
              <Dialog ref={(el) => { this.dialog = el }} />
              {this._renderEditButton(circle)}
            </td>
          </tr>
          <tr>
            <td>
              <TextField
                fieldName="Name"
                fieldContent={circle.name}
                edit={this.state.isEditing}
                onChange={(name) => this.setForm({ name, })}
              />
              <TextField
                fieldName="Description"
                fieldContent={circle.description}
                type="textarea"
                edit={this.state.isEditing}
                onChange={(description) => this.setForm({ description, })}
              />
            </td>
            <td>
              {this._renderStatusField(circle)}
              {this._renderStatusButtons(circle, circle.creation_status.status)}
            </td>
          </tr>
          <tr>
            <td>
              <TextField fieldName="Mode" fieldContent={circle.mode}/>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
}

CirclePanel.propTypes = ({
  circle : React.PropTypes.object,
  onUpdateCircle : React.PropTypes.func.isRequired
});

export default Relay.createContainer(CirclePanel, {
  initialVariables: {
    circleId: null,
    circleFetch: false,
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        id
        circle(id: $circleId) @include (if: $circleFetch) {
          id
          name
          mode
          description
          creation_status {
              status
              reason
          }
          address {
            address
            city
            country
          }
        }
      }
    `,
  }
});



// WEBPACK FOOTER //
// ./src/components/CirclePanel.js